import React, { useState } from 'react';

const UsernamePrompt = ({ isOpen, onClose, onSubmit, walletAddress, onCancel }) => {
  const [username, setUsername] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // Generate a random username
  const generateRandomUsername = () => {
    const adjectives = [
      'Swift', 'Bold', 'Clever', 'Brave', 'Fierce', 'Noble', 'Wise', 'Strong',
      'Quick', 'Sharp', 'Bright', 'Wild', 'Calm', 'Proud', 'Silent', 'Mighty',
      'Golden', 'Silver', 'Crimson', 'Azure', 'Emerald', 'Shadow', 'Storm', 'Flame'
    ];
    
    const nouns = [
      'Warrior', 'Hunter', 'Mage', 'Rogue', 'Knight', 'Archer', 'Guardian', 'Sage',
      'Blade', 'Arrow', 'Shield', 'Wand', 'Bow', 'Axe', 'Staff', 'Dagger',
      'Wolf', 'Eagle', 'Dragon', 'Phoenix', 'Tiger', 'Lion', 'Bear', 'Falcon',
      'Storm', 'Flame', 'Shadow', 'Light', 'Wind', 'Earth', 'Water', 'Fire'
    ];
    
    const randomAdjective = adjectives[Math.floor(Math.random() * adjectives.length)];
    const randomNoun = nouns[Math.floor(Math.random() * nouns.length)];
    const randomNumber = Math.floor(Math.random() * 999) + 1;
    
    return `${randomAdjective}${randomNoun}${randomNumber}`;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!username.trim()) {
      setError('Username is required');
      return;
    }

    if (username.length < 3) {
      setError('Username must be at least 3 characters long');
      return;
    }

    if (username.length > 20) {
      setError('Username must be less than 20 characters');
      return;
    }

    if (!/^[a-zA-Z0-9_-]+$/.test(username)) {
      setError('Username can only contain letters, numbers, underscores, and hyphens');
      return;
    }

    setLoading(true);
    setError('');

    try {
      await onSubmit(username.trim());
    } catch (err) {
      setError(err.message || 'Failed to set username');
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-gray-800 rounded-lg p-8 max-w-md w-full mx-4 border border-gray-700">
        <div className="text-center mb-6">
          <div className="text-4xl mb-4">👤</div>
          <h2 className="text-2xl font-bold text-white mb-2">Welcome to SoulWars!</h2>
          <p className="text-gray-300">
            Users must have a unique username to play.
          </p>
          <p className="text-gray-300">
            This will be your display name in games and leaderboards
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label htmlFor="username" className="block text-sm font-medium text-gray-300 mb-2">
              Username
            </label>
            <div className="flex gap-2">
              <input
                type="text"
                id="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Enter your username"
                disabled={loading}
                className="flex-1 px-4 py-3 bg-gray-700 border border-gray-600 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:opacity-50 disabled:cursor-not-allowed"
                autoFocus
              />
              <button
                type="button"
                onClick={() => setUsername(generateRandomUsername())}
                disabled={loading}
                className="px-4 py-3 bg-purple-600 hover:bg-purple-700 disabled:bg-gray-600 disabled:cursor-not-allowed text-white rounded-lg font-semibold transition-colors duration-200 whitespace-nowrap"
                title="Generate a random username"
              >
                🎲
              </button>
            </div>
            {error && (
              <p className="text-red-400 text-sm mt-1">{error}</p>
            )}
          </div>

          <div className="flex gap-3 pt-4">
            <button
              type="button"
              onClick={onCancel || onClose}
              disabled={loading}
              className="flex-1 bg-gray-600 hover:bg-gray-700 disabled:bg-gray-600 disabled:cursor-not-allowed text-white px-4 py-3 rounded-lg font-semibold transition-colors duration-200"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={loading || !username.trim()}
              className="flex-1 bg-blue-600 hover:bg-blue-700 disabled:bg-gray-600 disabled:cursor-not-allowed text-white px-4 py-3 rounded-lg font-semibold transition-colors duration-200"
            >
              {loading ? 'Setting up...' : 'Continue'}
            </button>
          </div>
        </form>

        <div className="mt-4 text-xs text-gray-400 text-center">
          <p>Wallet: {walletAddress ? `${walletAddress.slice(0, 6)}...${walletAddress.slice(-4)}` : 'Unknown'}</p>
        </div>
      </div>
    </div>
  );
};

export default UsernamePrompt;
